import {DialogContent, DialogTitle, FormHelperText, Link, Stack} from '@mui/material'
import {Trans} from 'react-i18next'
import {useRef} from 'react'
import {GoSchool} from '@goschool/routing'
import {SignInContextProvider} from './SignInContext'
import {GoogleSignInButton} from './GoogleSignInButton'
import {MicrosoftSignInButton} from './MicrosoftSignInButton'
import type {CredentialsSignInHandle} from './CredentialsSignIn'
import {CredentialsSignUp, CredentialsSignUpActions} from './CredentialsSignUp'
import {SignInError} from './SignInPage'

export function SignUpPage() {
  return <SignInContextProvider mode="signUp">
    <SignUpForm/>
  </SignInContextProvider>
}


function SignUpForm() {

  const credRef = useRef<CredentialsSignInHandle>(null)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // read the ref at call time; it may be null on first render
    credRef.current?.submit(e)
  }


  return <form onSubmit={handleSubmit}>
    <DialogTitle><Trans i18nKey="auth:signUp.form.title"/></DialogTitle>

    <DialogContent>
      <Stack gap={1} flexGrow={1}>
        <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
          <FormHelperText>
            <Trans i18nKey="auth:signUp.form.signUpWithOther"/>
          </FormHelperText>
          <Stack direction="row">
            <GoogleSignInButton/>
            <MicrosoftSignInButton/>
          </Stack>
        </Stack>

        <CredentialsSignUp ref={credRef}/>
        <SignInError/>
        <FormHelperText><SignUpConsent/></FormHelperText>
      </Stack>
    </DialogContent>
    <CredentialsSignUpActions/>
  </form>
}


export function SignUpConsent() {
  return <Trans i18nKey="auth:signUp.form.consent">
    <Link href={GoSchool.termsOfUse} target="_blank" rel="noopener noreferrer"/>
    <Link href={GoSchool.privacyStatement} target="_blank" rel="noopener noreferrer"/>
  </Trans>
}
